/**
 * Conversion Chart — TypeScript entry point.
 * Handles hidden-iframe print flow.
 */
import { initIframePrint } from './shared/iframe-print';

function init(): void {
    initIframePrint({
        formId: 'ccPrintForm',
        iframeId: 'ccPrintFrame',
        buttonId: 'ccPrintBtn',
        readyLabel: '<i class="bi bi-printer me-2" aria-hidden="true"></i>Print All Charts',
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
